export default "__VITE_ASSET__3796f8d9__"